import { useTheme } from '@emotion/react';
import styled from '@emotion/styled';

import { media } from '@myrealtrip/modash';
import { Text } from '@myrealtrip/web-ui';

import { CLOUD_FRONT_URL } from '~constants/common';

const AppealSection = () => {
  const theme = useTheme();

  return (
    <Container>
      <TextWrapper>
        <Text typography="headlineBold20" color={theme.colors.gray.s1000}>
          유럽 열차 예약,{' '}
        </Text>
        <Text typography="headlineBold20" color={theme.colors.blue.s500}>
          마리트
        </Text>
        <Text typography="headlineBold20" color={theme.colors.gray.s1000}>
          에서 해야하는 이유
        </Text>
      </TextWrapper>
      <AppealPoints>
        <AppealPoint>
          <AppealIcon
            alt=""
            aria-label="기차 아이콘"
            src={`${CLOUD_FRONT_URL}/transportation/assets/rail-europe/appeal-point/01.png`}
          />
          <AppealTextWrapper>
            <AppealTextTitle typography="headlineNormal17" color={theme.colors.gray.s1000} as="p">
              유럽 철도 플랫폼 공식 파트너
            </AppealTextTitle>
            <Text typography="paragraphNormal14" color={theme.colors.gray.s600}>
              레일유럽 공식 파트너로 믿고 구매할 수 있어요
            </Text>
          </AppealTextWrapper>
        </AppealPoint>
        <VerticalDivider />
        <AppealPoint>
          <AppealIcon
            alt=""
            aria-label="달력 아이콘"
            src={`${CLOUD_FRONT_URL}/transportation/assets/rail-europe/appeal-point/02.png`}
          />
          <AppealTextWrapper>
            <AppealTextTitle typography="headlineNormal17" color={theme.colors.gray.s1000} as="p">
              한국어로 쉽고 빠른 예약
            </AppealTextTitle>
            <Text typography="paragraphNormal14" color={theme.colors.gray.s600}>
              복잡한 단계 NO! 쉽고 빠르게 예약할 수 있어요
            </Text>
          </AppealTextWrapper>
        </AppealPoint>
        <VerticalDivider />
        <AppealPoint>
          <AppealIcon
            alt=""
            aria-label="전화 받는 사람 아이콘"
            src={`${CLOUD_FRONT_URL}/transportation/assets/rail-europe/appeal-point/03.png`}
          />
          <AppealTextWrapper>
            <AppealTextTitle typography="headlineNormal17" color={theme.colors.gray.s1000} as="p">
              믿을 수 있는 한국인 고객센터
            </AppealTextTitle>
            <Text typography="paragraphNormal14" color={theme.colors.gray.s600}>
              한국인 상담원이 빠르게 응대해드려요
            </Text>
          </AppealTextWrapper>
        </AppealPoint>
      </AppealPoints>
    </Container>
  );
};

const Container = styled.article`
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 20px 20px 24px 20px;
  margin: 28px 0 8px;

  ${media.minMobile} {
    margin: 40px 0 24px;
    padding: 20px 0 24px;
  }
`;

const TextWrapper = styled.div`
  text-align: left;
`;

const AppealPoints = styled.ul`
  display: grid;
  gap: 24px;
  width: 100%;
  padding: 20px 16px;
  border-radius: 12px;
  border: 1px solid ${({ theme }) => theme.colors.blue.s100};
  background-color: ${({ theme }) => theme.colors.blue.s50};

  ${media.minMobile} {
    grid-template-columns: 1fr 1px 1fr 1px 1fr;
    gap: 32px;
    padding: 24px 24px 20px 32px;
  }
`;

const AppealPoint = styled.li`
  position: relative;
  display: flex;
  align-items: center;
  gap: 8px;

  ${media.minMobile} {
    flex: 1;
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
  }
`;

const VerticalDivider = styled.div`
  display: none;

  ${media.minMobile} {
    display: block;
    width: 1px;
    height: 91px;
    background: ${({ theme }) => theme.colors.blue.s100};
    margin: auto;
  }
`;

const AppealIcon = styled.img`
  width: 40px;
  height: 40px;

  ${media.minMobile} {
    width: 48px;
    height: 48px;
  }
`;

const AppealTextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

const AppealTextTitle = styled(Text)`
  ${({ theme }) => theme.typography.headlineNormal16};
  ${media.minMobile} {
    ${({ theme }) => theme.typography.headlineNormal17};
  }
`;

export default AppealSection;
